import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { turkishCurrencyFormatterNoPrecision } from "../utils";
import LoadingBox from "./LoadingBox";

export default function SepetItemCreator(props) {
  const {
    showAddCard,
    setShowAddCard,
    features,
    setFeature,
    feature,
    decrementProductItemHandler,
    incrementProductItemHandler,
    product,
    sepeteEkleHandler,
    vazgecHandler,
    productQuantity,
    itemCreateLoading,
  } = props;

  const [productButtonName, setProductButtonName] = useState("");

  useEffect(() => {
    setProductButtonName(
      (feature && !feature.name.startsWith("Normal")
        ? feature.name + " "
        : "") + product.name
    );
  }, [feature, product]);
  return (
    <Modal size="sm" show={showAddCard} onHide={() => setShowAddCard(false)}>
      <Modal.Header closeButton>
        <Modal.Title>
          {features?.length > 0 && !feature ? (
            "Çeşit Seç"
          ) : (
            <div>
              {productQuantity + " "}
              <span>{!!feature && feature.name}</span>
              &nbsp;<span>{product.name}</span>
              &nbsp;
              <span>
                {turkishCurrencyFormatterNoPrecision(
                  productQuantity *
                    (product.price + (feature ? feature.price : 0))
                )}
              </span>
            </div>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-start",
          }}
        >
          {features?.length > 1 &&
            features.map((f) => (
              <Button
                onClick={() => {
                  setFeature(f);
                }}
                key={f.name}
                variant={feature._id === f._id ? "primary" : "success"}
                style={{
                  width: "120px",
                  aspectRatio: "2/1",
                  margin: "0.3rem",
                }}
              >
                <span
                  className={`${
                    f.name.length > 15 ? "text-bold small-font" : "text-bold"
                  }`}
                >
                  {f.name}
                </span>
              </Button>
            ))}
        </div>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-start",
          }}
        >
          <Button
            disabled={features?.length > 0 && !feature}
            style={{
              width: "120px",
              aspectRatio: "2/1",
              margin: "0.3rem",
            }}
            variant={
              features?.length > 0 && !feature
                ? "outline-secondary"
                : "outline-danger"
            }
            onClick={() => decrementProductItemHandler()}
          >
            <h4>
              <i className="fas fa-minus"></i>
              &nbsp;1
            </h4>
          </Button>

          <Button
            disabled={features?.length > 0 && !feature}
            style={{
              width: "120px",
              aspectRatio: "2/1",
              margin: "0.3rem",
            }}
            variant={
              features?.length > 0 && !feature
                ? "outline-secondary"
                : "outline-success"
            }
            onClick={() => incrementProductItemHandler()}
          >
            <h4>
              <i className="fas fa-plus"></i>
              &nbsp;1
            </h4>
          </Button>
          {product.isHalfPortion && (
            <>
              <Button
                disabled={features?.length > 0 && !feature}
                style={{
                  width: "120px",
                  aspectRatio: "2/1",
                  margin: "0.3rem",
                }}
                variant={
                  features?.length > 0 && !feature
                    ? "outline-secondary"
                    : "outline-danger"
                }
                onClick={() => decrementProductItemHandler(0.5)}
              >
                <h4>
                  <i className="fas fa-minus"></i>
                  &nbsp;1/2
                </h4>
              </Button>

              <Button
                disabled={features?.length > 0 && !feature}
                style={{
                  width: "120px",
                  aspectRatio: "2/1",
                  margin: "0.3rem",
                }}
                variant={
                  features?.length > 0 && !feature
                    ? "outline-secondary"
                    : "outline-success"
                }
                onClick={() => incrementProductItemHandler(0.5)}
              >
                <h4>
                  <i className="fas fa-plus"></i>
                  &nbsp;1/2
                </h4>
              </Button>
            </>
          )}
          <Button
            disabled={itemCreateLoading || (features?.length > 0 && !feature)}
            style={{
              width: "calc(240px + 0.6rem)",
              aspectRatio: "4/1",
              margin: "0.3rem",
              overflow: "hidden",
            }}
            variant={
              features?.length > 0 && !feature
                ? "outline-secondary"
                : "outline-success"
            }
            onClick={() => {
              sepeteEkleHandler();
            }}
          >
            {productButtonName.length > 26 ? (
              <div className="text-bold small-font">
                {productQuantity + " adet "}
                {productButtonName.substring(0, 26)}
              </div>
            ) : (
              <div className="text-bold ">
                {productQuantity + " adet "}
                {productButtonName.substring(0, 20)}
              </div>
            )}
            <div className="text-bold">
              <span>Sepete Ekle</span>
            </div>
          </Button>

          <Button
            disabled={itemCreateLoading}
            style={{
              width: "calc(240px + 0.6rem)",
              aspectRatio: "4/1",
              margin: "0.3rem",
            }}
            variant="outline-danger"
            onClick={() => {
              vazgecHandler();
            }}
          >
            <div className="text-bold">
              <i className="fas fa-close"></i>&nbsp;
              {"Vazgeç"}
            </div>
          </Button>
          {itemCreateLoading && <LoadingBox></LoadingBox>}
        </div>
      </Modal.Body>
    </Modal>
  );
}
